// extracted by mini-css-extract-plugin
export default {"logo-link":"logo-link_logo-link__MH244"};